<script lang="ts">
    import {createEventDispatcher} from 'svelte';

    export let emojis = ["✌️","😂","😝","😁","😱","👉","🙌","🍻","🔥","🌈","☀️","🎈","🌹","💄","🎀","⚽","🎾","🏁","😡","👿","🐻","🐶","🐬","🐟","🍀","👀","🚗","🍎","💝","💙","👌","❤","😍","😉","😓","😳","💪","💩","🍸","🔑","💖","🌟","🎉","🌺","🎶","👠","🏈","⚾","🏆","👽","💀","🐵","🐮","🐩","🐎","💣","👃","👂","🍓","💘","💜","👊","💋","😘","😜","😵","🙏","👋","🚽","💃","💎","🚀","🌙","🎁","⛄","🌊","⛵","🏀","🎱","💰","👶","👸","🐰","🐷","🐍","🐫","🔫","👄","🚲","🍉","💛","💚"]
    export let fontSize = '20px'

    const dispatch = createEventDispatcher();

    function select(emoji) {
        dispatch('emoji-selected', emoji);
    }
</script>


<div class="panel">
    {#each emojis as emoji}
        <button class="emoji" on:click={() => select(emoji)} style="font-size: {fontSize}">
            {emoji}
        </button>
    {/each}
</div>


<style lang="scss">
  .emoji {
    background-color: rgba(0,0,0,0);
    border: 0;
    cursor: pointer;

    &:hover {
      background-color: rgba(150,150,150,0.2);
      transition: all 0.5s;
    }
  }
</style>